import "./TemplateWindow.scss";
import { useEffect, useRef, useState } from "react";
import { addDraft, getTemplateById, sendMessage } from "../Api";
import DialogWindow from "../../CommonComponents/DialogWindow/DialogWindow";
import DraftWindow from "./DraftsWindow/DraftWindow";
import DraftSaveDialog from "./DraftSaveDialog/DraftSaveDialog";
import { usePrsInfo } from "../effects";

function TemplateWindow(props) {
	const [openDraftDialog, setOpenDraftDialog] = useState(false);
	const [openDraftSaveDialog, setOpenDraftSaveDialog] = useState(false);
	const formRef = useRef();
	const prsInfo = usePrsInfo();
	const handleDraftSelected = (e) => {
		const form = formRef.current;
		const formData = new FormData(form);
		const draftData = JSON.parse(e.target.value);
		Object.keys(draftData).map((key) => {
			formData.set(key, draftData[key]);
		});
		console.log(formData);
		for (const [key, val] of formData.entries()) {
			const input = formRef.current.elements[key];
			switch (input.type) {
				case "checkbox":
					input.checked = !!val;
					break;
				default:
					input.value = val;
					break;
			}
		}
	};
	const datetime = () => {
		const currentdate = new Date();
		return (
			currentdate.getDate().toString().padStart(2, 0) +
			"/" +
			(currentdate.getMonth() + 1).toString().padStart(2, 0) +
			"/" +
			currentdate.getFullYear() +
			" @ " +
			currentdate.getHours().toString().padStart(2, 0) +
			":" +
			currentdate.getMinutes().toString().padStart(2, 0) +
			":" +
			currentdate.getSeconds().toString().padStart(2, 0)
		);
	};
	const handleAddDraft = (e, draftName) => {
		e.preventDefault();
		const form = formRef.current;
		const formData = new FormData(form);
		let formJson = Object.fromEntries(formData.entries());
		addDraft(
			draftName,
			props.currentTemplateInfo.id,
			JSON.stringify(formJson),
			prsInfo.prs_alias
		)
			.then((res) => {
				props.setInfo({
					message: "Черновик успешно сохранен",
					background: "var(--green)",
					color: "var(--font-color)",
					timeout: 5000,
				});
				setOpenDraftSaveDialog(false);
			})
			.catch(() => {
				props.setInfo({
					message: "Ошибка при сохранении",
					timeout: 5000,
				});
				setOpenDraftSaveDialog(false);
			});
	};
	const handleSubmit = (e) => {
		// Prevent the browser from reloading the page
		e.preventDefault();
		const form = e.target;
		const formData = new FormData(form);
		let formJson = Object.fromEntries(formData.entries());
		formJson = {
			templateId: props.currentTemplateInfo.id,
			templateName: props.currentTemplateInfo.name,
			data: { ...formJson },
		};
		console.log(formJson);

		sendMessage(props.activeContact, JSON.stringify(formJson)).then(() => {
			props.setTemplateWindowOpen(false);
		});
	};
	const template = useTemplate(props.currentTemplateInfo);
	return (
		<>
			<DialogWindow setOpen={props.setTemplateWindowOpen}>
				<div className='template-window'>
					<h2>{props.currentTemplateInfo.name}</h2>
					<form ref={formRef} method='post' onSubmit={handleSubmit}>
						{template.map((item) => {
							return item.Type === "instruction" ? (
								<div style={{ width: "98.5%" }}>
									{item.Strings.map((i) => (
										<div style={{ fontSize: "1em" }}>{i}</div>
									))}
								</div>
							) : (
								<div
									style={
										item.Width === "1"
											? { width: "98.5%" }
											: item.Width === "1/2"
											? { width: "49%", padding: "0 0.2em" }
											: { width: "32%", padding: "0 0.2em" }
									}
								>
									<label>
										{item.Label}
										{item.Required ? "(обязательное)" : ""}
									</label>
									<input
										name={`${item.Name}`}
										className='template-input'
										type={item.Type}
										required={item.Required}
									/>
								</div>
							);
						})}
						<div
							style={{
								width: "100%",
								display: "flex",
								gap: "0.5em",
								justifyContent: "flex-end",
							}}
						>
							<button
								onClick={(e) => {
									e.preventDefault();
									setOpenDraftDialog(true);
								}}
							>
								Архив
							</button>
							<button
								onClick={(e) => {
									e.preventDefault();
									setOpenDraftSaveDialog(() => true);
								}}
							>
								Сохранить черновик
							</button>
							<button type='submit'>Отправить</button>
							<button onClick={() => props.setTemplateWindowOpen(false)}>
								Закрыть
							</button>
						</div>
					</form>
					<div className='button-block'></div>
				</div>
			</DialogWindow>
			{openDraftDialog ? (
				<DraftWindow
					currentTemplateInfo={props.currentTemplateInfo}
					setOpenDraftDialog={setOpenDraftDialog}
					formRef={formRef}
				/>
			) : null}
			{openDraftSaveDialog ? (
				<DraftSaveDialog
					handleAddDraft={handleAddDraft}
					setOpenDraftSaveDialog={setOpenDraftSaveDialog}
				/>
			) : null}
		</>
	);
}

const useTemplate = (currentTemplateInfo) => {
	const [template, setTemplate] = useState([]);
	useEffect(() => {
		getTemplateById(currentTemplateInfo.id).then((res) => {
			setTemplate(JSON.parse(res[0].PATT_JSON).Fields);
		});
	}, [currentTemplateInfo.id]);

	return template;
};

export default TemplateWindow;
